import { store } from "@betacrew/jars-flux";
import { all, put, takeLatest } from "redux-saga/effects";
import IntegrationDataService from "../../../../../services/IntegrationDataService";
import { INTEGRATION_WRAPPER_LOADING_STATES } from "../constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { setLoadingState, setTenantList, setFormAndTaxYearList, setImportData, setFormSettings, setIsImportDataGridViewLoaded, componentKey as entrataComponentKey } from "./EntrataSlice";
import FormsDataService from "../../../../../services/FormsDataService";

export const{ getFormAndTaxYearList, connectToEntrata, getLoadImportData, getFormSetting } = {
    getFormAndTaxYearList: (payload) => {
        return {
            type: "ENTRATA/GET_FORMS_TAXTEAR_LIST",
            payload: payload
        }
    },
    connectToEntrata: (payload) => {
        return {
            type: "ENTRATA/GET_CONNECTENTRATA",
            payload: payload
        }
    },
    getLoadImportData: (payload) => {
        return {
            type: "ENTRATA/GET_LOAD_IMPORT_DATA",
            payload: payload
        }
    },
    getFormSetting: (payload) => {
        return {
            type: "ENTRATA/GET_FORM_SETTING",
            payload: payload
        }
    },
}

function* getFormAndTaxYearListAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.getTaxYearFormTypes();
        if (response?.data?.Status == 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if(response?.data?.Data){
                yield put(setFormAndTaxYearList(response?.data?.Data));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch TaxYear And Form Types", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* connectToEntrataAsync() {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const response = yield IntegrationDataService.connectToEntrata();
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                const tenantData = response?.data?.Data || [];
                yield put(setTenantList(tenantData));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to Connect Entrata",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }
    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to Connect Entrata", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getLoadImportDataAsync(action) {
    try {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_LOADING }));
        const { integrationImportRequestDto } = action.payload;
        const response = yield IntegrationDataService.getIntegrationImportData(integrationImportRequestDto);
        if (response?.data?.Status === 0) {
            yield put(addNotifications({
                heading: "Error",
                message: response?.data?.Message,
                variant: TOASTER_VARIANT.DANGER
            }));
        }
        else if (response?.data?.Status == 1) {
            if (response.data.Data) {
                yield put(setImportData(response?.data?.Data));
                yield put(setIsImportDataGridViewLoaded(true));
            }
            else {
                yield put(addNotifications({
                    heading: "Error",
                    message: "Failed to fetch Import Data",
                    variant: TOASTER_VARIANT.DANGER
                }));
            }
        }

    } catch (error) {
        console.log(error);
        yield put(addNotifications({ heading: "Failed to fetch Import Data", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    }
    finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GRID_DATA_READY }));
    }
}

function* getFormSettingAsync(action) {
    try {
        const { formId, year } = action.payload;
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_LOADING }));
        const response = yield FormsDataService.getFormSetting(formId, year);
        if (response?.data) {
            if (response?.data?.Status === 1) {
                if (response.data.Data) {
                    yield put(setFormSettings(response?.data?.Data));
                }
                else {
                    yield put(addNotifications({
                        heading: "Error",
                        message: "An error occurred while fetching the Data",
                        variant: TOASTER_VARIANT.DANGER
                    }));
                }
            } else {
                yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
            }
        }
    } catch (error) {
        console.log(error)
        yield put(addNotifications({ heading: "Error", message: "An error occurred while fetching the Data. Please try again later or contact our support team for assistance.", variant: TOASTER_VARIANT.DANGER }));
    } finally {
        yield put(setLoadingState({ state: INTEGRATION_WRAPPER_LOADING_STATES.GET_FORM_SETTINGS_READY }))
    }
}


function* rootSaga() {
    yield all([
        takeLatest(getFormAndTaxYearList().type, getFormAndTaxYearListAsync),
        takeLatest(connectToEntrata().type, connectToEntrataAsync),
        takeLatest(getLoadImportData().type, getLoadImportDataAsync),
        takeLatest(getFormSetting().type, getFormSettingAsync),
    ]);
}
store.sagaManager.addSaga(entrataComponentKey, rootSaga);